import * as React from 'react';
import ChartComponent, { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { numberWithCommas, currencyFormat } from '../../helpers';
import { TheBrain } from '../../data/brain';


declare var Chart: any;
Chart.defaults.global.defaultFontFamily = "'Bitter', serif";
// https://chartjs-plugin-datalabels.netlify.com/guide/getting-started.html#configuration
// Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
//     color: '#FFF'
// });


const successRateGridFromOutputSpreadsheet = `
0.5	1	1	0.5	2	1
1	1	0.5	1	1	2
1	0.5	1	2	0.5	1
1	0.5	1	2	0.5	1
`;

const successRateGrid = successRateGridFromOutputSpreadsheet
    .split("\n").map(g => g.trim()) // split lines
    .map(g => g.split("\t").map(g => parseFloat(g.trim())))
    .map(g => [1, ...g]) // note, adding 1 to first column so the maths works out for the total column
    .filter(g => g.length == 7) // split each number
    ;

export interface OutcomesProps {
    brain: TheBrain;
}

export const Outcomes = (props: OutcomesProps) => {

    const darkBlue = "#1d8bcc";
    const lightBlue = "#7ac1ec";

    const { brain } = props;

    const incomes = [brain.getStreamingIncome(), brain.getTrackDownloadIncome(), brain.getAlbumDownloadIncome(), brain.getPhysicalAlbumIncome()];

    // successRateGrid

    const getTotal = (column: number) =>
        incomes
            .map((a, row) => incomes[row] * successRateGrid[row][column])
            .reduce((a, b) => a + b, 0);

    const chartDataSetData = [0, 1, 2, 3, 4, 5, 6].map(c => getTotal(c));

    const chartData = {
        labels: [
            ["Target"],
            ["Half as good", "on the streams"],
            ["Half as good on", "the albums"],
            ["Half as good on", "the tracks"],
            ["Half as good on", "the streams but", "twice as good on", "the albums"],
            ["Twice as good on", "the streams and", "half as good on", "the albums"],
            ["Twice as good on", "the track", "downloads"]
        ].map(s => s.map(ss => ss.toUpperCase())),
        datasets: [
            {
                // label: "blaaa",
                backgroundColor: [darkBlue, lightBlue, lightBlue, lightBlue, lightBlue, lightBlue, lightBlue],
                data: chartDataSetData,
            },
        ]
    }
    // debugger;


    return <div className="outcomes">
        <div className="chart">
            <Bar
                data={chartData}
                // https://chartjs-plugin-datalabels.netlify.com/guide/getting-started.html#integration
                plugins={[ChartDataLabels]}
                options={{
                    // very important that the reposnive and aspect setting stay where they are
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: false,
                    },
                    plugins: {
                        // Change options for ALL labels of THIS CHART
                        datalabels: {
                            color: '#FFF',
                            formatter: function (value: any, context: any) {
                                const v = context.chart.data.datasets[0].data[context.dataIndex];
                                return currencyFormat(Math.round(v as number));
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                // labelString: options.yLabel
                            },
                            // adds commas to the y axis value
                            ticks: {
                                beginAtZero: true,
                                callback: (label: any, index: any, labels: any) => {
                                    return numberWithCommas(Math.round(label as number));
                                }
                                // callback: function (label, index, labels) {
                                //     return numberWithCommas(label as number);
                                // },
                                // suggestedMax: options.max
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0, // makes the text horizontal
                                minRotation: 0,
                                // callback: (x: any, y: any, z: any) => {
                                //     debugger;
                                // }
                            }
                        }]

                    },
                    legend: {
                        display: false,
                    },
                    // animation: {
                    //     duration: options.disableAnimations ? 0 : 1000,
                    // }

                }}
                redraw={false}
                width={950}
                height={400}

            />
        </div>
    </div>

}